import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import MarkdownRenderer from './MarkdownRenderer';
import { formatDate } from '../utils';
import BackLink from './BackLink';
import { Link } from 'react-router-dom';
import './shared.css';

function BlogTemplate({ post, relatedProject }) {

  let relatedProjectTitle = null;
  if (relatedProject) {
    relatedProjectTitle = relatedProject.title;
  }

  return (
    <Container className="py-5">
      <Row>
        <Col>
          <BackLink toLink="/blog" linkText="Back to all blog posts" />
        </Col>
      </Row>

      <Row>
        <Col>
          <h1 className="page-title">{post.title}</h1>
        </Col>
      </Row>

      <Row>
        <Col>
          <time className="blog-post-date" dateTime={post.publishedAt}>
            {formatDate(post.publishedAt)}
          </time>
        </Col>
      </Row>

      <Row>
        <Col>
          {relatedProjectTitle && (
            <Button variant="link" className="mb-4 px-0" as={Link} to={`/projects/${relatedProject.slug}`}>
              Related Project: {relatedProjectTitle}
            </Button>
          )}
        </Col>
      </Row>


      <Row>
        <Col>
          <div className="blog-body">
            <MarkdownRenderer filePath={post.markdownPath} />
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export { BlogTemplate };